import { useRef } from 'react';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { MenuItem } from 'primereact/menuitem';
import { ProfessionalSettlementDTO } from '../../dto/ProfessionalSettlementDTO';

interface SettlementRowActionsProps {
    settlement: ProfessionalSettlementDTO;
    onViewDetail: (settlement: ProfessionalSettlementDTO) => void;
    onViewForms: (settlement: ProfessionalSettlementDTO) => void;
    onDownloadSummary: (settlement: ProfessionalSettlementDTO) => void;
    onRegisterAdditionalPayment: (settlement: ProfessionalSettlementDTO) => void;
}

/** Acciones de una fila del historial de rendiciones: menú ⋮ con ítems neutros (DS §3.1). */
export default function SettlementRowActions({
    settlement,
    onViewDetail,
    onViewForms,
    onDownloadSummary,
    onRegisterAdditionalPayment,
}: SettlementRowActionsProps) {
    const menuRef = useRef<Menu>(null);

    const items: MenuItem[] = [
        { label: 'Ver detalle', icon: 'pi pi-eye', command: () => onViewDetail(settlement) },
        { label: 'Ver comprobantes', icon: 'pi pi-file', command: () => onViewForms(settlement) },
        ...(settlement.internalreceiptform != null
            ? [{ label: 'Descargar resumen', icon: 'pi pi-download', command: () => onDownloadSummary(settlement) }]
            : []),
        ...(settlement.pendingamount > 0
            ? [{ label: 'Registrar pago adicional', icon: 'pi pi-wallet', command: () => onRegisterAdditionalPayment(settlement) }]
            : []),
    ];

    return (
        <>
            <Menu model={items} popup ref={menuRef} className="md-menu" />
            <Button
                text
                rounded
                icon="pi pi-ellipsis-v"
                className="md-icon-btn"
                aria-label={`Acciones del cierre N° ${settlement.closingnumber}`}
                aria-haspopup
                tooltip="Acciones"
                tooltipOptions={{ position: 'left' }}
                onClick={event => menuRef.current?.toggle(event)}
            />
        </>
    );
}
